(function() { window.GUID_07114e11_1bfa_47ec_8f1a_c3775f17c0a4 = { getGuid: function() { return "07114e11-1bfa-47ec-8f1a-c3775f17c0a4"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class SplashScreen extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.$control = $('#' + params[0]); //contient le Id
                let me = this;
                setTimeout(function () {
                    me.$Control.addClass('loaded');
                    setTimeout(function () {
                        me.$Control.remove();
                    }, 1000);
                }, 1000);
            }
            OnDispose() {
                this.$Control.remove();
            }
            OnBindEvents() { }
        }
        Controls.SplashScreen = SplashScreen;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=splashscreen.js.map
